module.exports = __webpack_public_path__ + "495b80158e530cc2b23a2014809a3c4b.png";